/**
 * @file camp-builder-lead.js
 * Shared helper for pushing camp_builder_lead events to imgaDataLayer at
 * add-to-cart success. Consumed by router.js and participantSelector.js.
 *
 * Payload: { event, camp_lead: { email, phone, interest, sport, product_type, event_id } }
 */
(function (window) {
  'use strict';

  function normalize(value) {
    if (value === null || value === undefined) return null;
    var trimmed = String(value).trim();
    return trimmed === '' ? null : trimmed;
  }

  /**
   * Push a camp_builder_lead event to window.imgaDataLayer.
   *
   * @param {Object} customer
   * @param {string} [customer.email]
   * @param {string} [customer.phone]
   * @param {string} [customer.interest]
   * @param {string} [customer.sport]
   * @param {string} [customer.product_type]
   * @param {string} [customer.event_id]
   * @param {Function} [onComplete] - called after GTM fires eventCallback (or after timeout)
   */
  function pushCampBuilderLead(customer, onComplete) {
    customer = customer || {};
    window.imgaDataLayer = window.imgaDataLayer || [];

    var payload = {
      event: 'camp_builder_lead',
      camp_lead: {
        email: normalize(customer.email),
        phone: normalize(customer.phone),
        interest: normalize(customer.interest),
        sport: normalize(customer.sport),
        product_type: normalize(customer.product_type),
        event_id: normalize(customer.event_id)
      }
    };

    if (typeof onComplete === 'function') {
      var called = false;
      var guardedOnComplete = function () {
        if (called) return;
        called = true;
        onComplete();
      };
      payload.eventCallback = guardedOnComplete;
      payload.eventTimeout = 1500;
      window.imgaDataLayer.push(payload);
      setTimeout(guardedOnComplete, 1600);
    } else {
      window.imgaDataLayer.push(payload);
    }
  }

  window.pushCampBuilderLead = pushCampBuilderLead;
})(window);
